<template>
  <el-card class="w1200">
    <div>
      <el-button
        class="login"
        @click="handleLogin"
        v-if="userInfo.username == ''">
        登录
      </el-button>
      <el-dropdown class="userinfo" @command="handleLogout" v-else>
        <div class="userlogin">
          <el-avatar :src="userInfo.img" v-if="userInfo.img != ''"></el-avatar>
          <span class="name">{{ userInfo.username }}</span>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <img v-if="special=='MTA0'" class="titleImg" src="../assets/image/school.jpg" alt="加载失败" />
    <el-image v-else :src="src" :key="src" />
    <nav>
      <a
        v-for="item in nav"
        :key="item.name"
        :style="{ width: 100 / nav.length + '%' }"
        :class="on === item.href ? 'active-select' : ''"
        @click="handleClick(item.href)"
      >
        {{ item.name }}
      </a>
    </nav>
    <el-dialog :visible.sync="loginDialog" class="login-dialog">
      <div v-if="loginType == ''">
        <el-image
          fit="scale-down"
          src="https://www.mools.net/lims/web/DeclarationWebsite/img/dllogo.png"
          style="height: 100px"
        ></el-image>
        <br />
        <el-row>
          <el-col :span="6" :offset="6">
            <div @click="loginType = 'wechat'">
              <el-avatar
                :size="50"
                src="https://sss.qingting.fm/neo/login/wechat@2x.png"
                style="background-color: #fff;"
              ></el-avatar>
              <p>微信登录</p>
            </div>
          </el-col>
          <el-col :span="6">
            <div @click="loginTourist">
              <el-avatar
                :size="50"
                src="https://www.mools.net/lims/web/DeclarationWebsite/img/%E6%B8%B8%E5%AE%A2%E4%BF%A1%E6%81%AF.png"
                style="background-color: #fff;"
              ></el-avatar>
              <p>游客登录</p>
            </div>
          </el-col>
        </el-row>
      </div>
      <div v-else-if="loginType == 'wechat'">
        <wechat-login
          :config="wechatConfig"
          @onLogin="handleWechatLogin"
        ></wechat-login>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  ToDecrypt,
  getHeaderImage,
  loginWithCode,
  touristLogin,
  logout
} from "@/api/components/header";
import WechatLogin from "./WechatLogin";

export default {
  name: "Header",
  components: {
    WechatLogin
  },
  props: {
    expId: String
  },
  data() {
    return {
      wechatConfig: {
        appid: "wxc4886b0644c55d2d",
        wechatid: "wx28eafcab238c2371",
        redirect_uri: "https://www.mools.net/lims/web/wechat/login.html"
      },
      on: "/",
      src: null,
      nav: [
        { name: "首页", href: "/" },
        { name: "实验目的", href: "/purpose" },
        { name: "服务团队", href: "/service" },
        { name: "实验原理", href: "/theory" },
        { name: "实验方法与步骤", href: "/step" },
        { name: "实验考核要求", href: "/require" },
        { name: "实验项目特色", href: "/character" },
        { name: "面向学生要求", href: "/tostu" }
      ],
      loginDialog: false,
      loginType: "",
      userInfo: {
        username: "",
        img: ""
      },
      // 是否是西安电子科技大学专门定做的页面（url的School_id参数为'MTA0'时）
      special : this.$route.query.School_id
    };
  },
  watch: {
    // 监听实验ID修改事件
    expId(val) {
      // 判断用户来源
      this.getSourceOfTheUser(val);
    },
    "$route.path": function(path) {
      this.on = path;
    },
    "$route.query.School_id": function(School_id) {
      this.handleGetHeaderImage(School_id);
      loginWithCode({
        ticket: this.$route.query.ticket,
        id: atob(this.$route.query.School_id)
      }).then(res => {
        if(res.id == 159163 || res.id == 159162)
        {// 重庆师范对接
          localStorage.setItem("un", res.nickname);
        }
        else
        {
          localStorage.setItem("un", res.ilab_username);
        }
        this.userInfo.username = res.nickname;
        this.$store.commit("setUserInfo", res.nickname);
        this.userInfo.img = res.wx_img;
        // =======================================================
        // 重庆师范对接 add by camellia 20231013
        let accessToken = res.access_token ?? '';
        let appId = res.appid ?? '';
        let openId = res.openid ?? '';
        let secretKey = res.secretKey ?? '';
        let ticket = res.ticket ?? '';
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("appId", appId);
        localStorage.setItem("openId", openId);
        localStorage.setItem("secretKey", secretKey);
        localStorage.setItem("ticket", ticket);
      });
    },
    "$store.state.loginDialogStatus": function(status) {
      if (status) {
        this.loginDialog = status;
      }
    },
    loginDialog(status) {
      this.$store.commit("setLoginDialog", status);
    }
  },
  created() {
    this.on = this.$route.path;
    console.log(this.$route.query.School_id);
    // ADD BY LANXINYU =============================================================================================
    // 西安电子科技大学定制的页面
    if(this.$route.query.School_id == 'MTA0')
    {
      this.nav = [
        { name: "首页", href: "/" },
        { name: "服务团队", href: "/service" },
        { name: "实验简介", href: "/step" },
        { name: "实验目的", href: "/purpose" },
        { name: "实验内容", href: "/character" },
        { name: "实验原理", href: "/theory" },
        { name: "考核要求", href: "/require" },
        { name: "实验须知", href: "/tostu" },
      ]
      // 是否是西安电子科技大学专门定做的页面（true-定制页面，false-正常页面）
      // this.special = 'MTA0';
      // this.$store.commit('setSpecial','MTA0')
    // ================================================================================================================
    }
    if (this.$route.query.School_id) {
      loginWithCode({
        ticket: this.$route.query.ticket,
        id: atob(this.$route.query.School_id)
      }).then(res => {
        if(res.id == 159163 || res.id == 159162)
        {// 重庆师范对接
          localStorage.setItem("un", res.nickname);
        }
        else
        {
          localStorage.setItem("un", res.ilab_username);
        }
        this.userInfo.username = res.nickname;
        this.$store.commit("setUserInfo", res.nickname);
        this.userInfo.img = res.wx_img;
        // =======================================================
        // 重庆师范对接 add by camellia 20231013
        let accessToken = res.access_token ?? '';
        let appId = res.appid ?? '';
        let openId = res.openid ?? '';
        let secretKey = res.secretKey ?? '';
        let ticket = res.ticket ?? '';
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("appId", appId);
        localStorage.setItem("openId", openId);
        localStorage.setItem("secretKey", secretKey);
        localStorage.setItem("ticket", ticket);
      });
    }
    this.handleGetHeaderImage(this.$route.query.School_id);
  },
  methods: {
    // 游客登录
    loginTourist() {
      touristLogin().then(res => {
        this.loginDialog = false;
        this.userInfo.username = res.nickname;
        this.userInfo.img = res.wx_img;
        this.$store.commit("setLoginDialog", false);
        this.$store.commit("setUserInfo", res.nickname);
      });
    },
    // 退出
    handleLogout(command) {
      if (command == "logout") {
        logout().then(res => {
          if (res.code == 1) {
            this.userInfo.username = "";
            this.userInfo.img = "";
          }
        });
      }
    },
    // 微信登录拿到code
    handleWechatLogin(code, args) {
      loginWithCode({
        ticket: this.$route.query.ticket,
        id: atob(this.$route.query.School_id),
        code,
        args
      }).then(res => {
        if(res.id == 159163 || res.id == 159162)
        {// 重庆师范对接
          localStorage.setItem("un", res.nickname);
        }
        else
        {
          localStorage.setItem("un", res.ilab_username);
        }
        this.loginDialog = false;
        this.userInfo.username = res.nickname;
        this.userInfo.img = res.wx_img;
        this.$store.commit("setLoginDialog", false);
        this.$store.commit("setUserInfo", res.nickname);
        // =======================================================
        // 重庆师范对接 add by camellia 20231013
        let accessToken = res.access_token ?? '';
        let appId = res.appid ?? '';
        let openId = res.openid ?? '';
        let secretKey = res.secretKey ?? '';
        let ticket = res.ticket ?? '';
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("appId", appId);
        localStorage.setItem("openId", openId);
        localStorage.setItem("secretKey", secretKey);
        localStorage.setItem("ticket", ticket);
      });
    },
    handleGetHeaderImage(School_id) {
      if (School_id) {
        getHeaderImage(School_id).then(res => {
          if (res.data) {
            this.src = res.data.header_image;
          }
        });
      }
    },
    /**
     * @name handleClick
     * @desc 用户点击标签页，带参数跳转页面
     * @param [String] href 链接地址
     */
    handleClick(href) {
      const queryString = window.location.href.split("?")[1];
      this.$router.push(href + (queryString ? "?" + queryString : ""));
    },
    /**
     * @name handleLogin
     * @desc 用户点击登录
     */
    handleLogin() {
      // 显示登录弹窗
      this.loginDialog = true;
    },
    /**
     * @name getSourceOfTheUser
     * @desc 判断用户来源
     * @param [String] expId 实验ID
     */
    getSourceOfTheUser(expId) {
      const token = this.$route.query.token || "";
      if (token === "") {
        //直接访问链接，检查用户session
        this.checkUserLoginStatus("");
      } else {
        //ilabx跳转
        this.checkIlabxToken(token, expId, function() {});
      }
    },
    checkUserLoginStatus(ilabx_username) {
      console.log(ilabx_username);
    },
    checkIlabxToken(token, expId, callback) {
      ToDecrypt({
        exp_id: expId,
        jwttoken: token
      }).then(res => {
        console.log(res);
        console.log(callback);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  /* 图片高度 */
  $image-height: 400px;
  /* 导航栏高度 */
  $nav-height: 40px;
  /* 导航栏偏移高度 */
  $nav-position: -30px;

  .el-card {
    position: relative;
    height: $image-height + $nav-height + $nav-position;
    border: none;
    border-radius: 0px;

    /deep/ .el-card__body {
      padding: 0px;
    }
  }

  .el-image {
    height: $image-height;
    display: block;
  }

  nav {
    position: relative;
    top: $nav-position;
    background-color: #15356c;

    a {
      display: inline-block;
      height: $nav-height;
      line-height: $nav-height;
      color: #fff;
      text-decoration: none;
      cursor: pointer;
    }
  }

  .active-select {
    background-color: #d3dced;
    color: $--color-text-primary;
  }

  .login {
    background-color: rgba(21, 53, 108, 0.8);
    border: none;
    border-radius: 0px;
    float: right;
    position: absolute;
    top: 10px;
    right: 10px;
    padding: 12px 30px;
    z-index: 2;
    color: #fff;

    &:hover {
      color: #477dbf;
    }
  }

  .userinfo {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 2;

    .userlogin {
      background-color: rgba(21, 53, 108, 0.2);
      border: none;
      border-radius: 0px;
      padding: 6px 10px 3px;
      color: #fff;
      cursor: pointer;

      .name {
        display: inline-block;
        box-sizing: border-box;
        text-align: center;
        overflow: hidden;
        color: #fff;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
      }

      .el-avatar {
        margin-right: 20px;
      }
    }
  }

  .login-dialog {
    /deep/ .el-dialog__header {
      padding: 0;
    }
  }
.titleImg{
  width:100%;
  height: 395px;
}
</style>
